#import "../ChartOfAccountFields.graphql"
query ChartOfAccount($id: UUID!) {
  chartOfAccount(id: $id) {
    ...ChartOfAccountFields
  }
}
